import { ActivityStatus } from 'connect-graphql/generated';
import { DateTime } from 'luxon';

import { safelyConvertDate } from '@craft/lib/dates';

/**
 * Determines whether or not the activity is overdue based on it's status, {@link ActivityStatus}.
 *
 * @param {Date | DateTime | null | undefined} activityDueDate
 *   The activity's due date.  If not provided, it will not be considered overdue.
 * @param {ActivityStatus} status The current activity status.
 *
 * @returns {boolean} Whether or not the activity status {@link ActivityStatus} is overdue.
 */
export const isActivityOverdue = (
  activityDueDate: Date | DateTime | null | undefined,
  status: ActivityStatus,
): boolean => {
  if (!activityDueDate) {
    return false;
  }
  const dueDate = safelyConvertDate(activityDueDate, { strict: true });
  return dueDate < DateTime.local() && status === ActivityStatus.Unsubmitted;
};
